import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useAccountId } from "../Auth/auth-functions";
import { api } from "./api";
import { MutableCommentDto } from "../models/comments.models";
import { EventSource } from "../models/event.models";

export const useCreateCommentMutation = () => {
	const queryClient = useQueryClient();
	const accountId = useAccountId();

	return useMutation<unknown, Error, MutableCommentDto>({
		mutationFn: (model) => {
			return api.post('/comments', model);
		},
		onSuccess: (_data, model) => {
			if (model.SourceType == EventSource.WorkOrder)
				queryClient.invalidateQueries({ queryKey: ['workorder', accountId, model.SourceId] });
		}
	});
}